import React,{useContext} from 'react';
import ArrowDown from '@mui/icons-material/KeyboardArrowDown';
import './select.css';

import commonTranslations from '../languages/common.json';
import { LanguageContext } from '../context/LanguageContext';


const Select = ({ id, options, selected, update, toTop,isObjectList=true }) => {
    const { lang } = useContext(LanguageContext);
    const t = commonTranslations[lang].common.Select;
    const addListener = () => {
        const list = document.getElementById(id + '-list'),
            section = document.getElementById(id + '-section');
        list.classList.add('show');
        section.classList.add('selected');
    };

    const removeListener = () => {
        const list = document.getElementById(id + '-list'),
            section = document.getElementById(id + '-section');
        list.classList.remove('show');
        section.classList.remove('selected');
        document.documentElement.removeEventListener('mouseup', removeListener);
    };

    const select = () => {
        addListener();
        document.documentElement.addEventListener('mouseup', removeListener);
    };

    return (
        <div className='select-wrapper'>
            <div id={id + '-section'} className='select-selection' onClick={select}>
                <span className='select-selection-item'>
                    {selected}
                </span>
                <span className='select-icon'>
                    <ArrowDown style={{ transform: toTop ? 'rotate(180deg)' : '' }} />
                </span>
            </div>
            <ul id={id + '-list'} className='select-list' title={t.role} style={
                toTop ? { top: '-550%', bottom: '110%' } : {}
            }>
                {options.map((option, ix) => (
                    <li className='select-list-item' title={isObjectList?option.name:option}
                        key={ix} style={{ color: 'var(--cell-color)', padding: '8px 12px' }}
                        onClick={() => update(option)}>
                        {isObjectList?option.name:option}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default Select;